import React, { memo } from 'react';
import { Box, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';

import DrawerToggle from './DrawerToggle';
import SectionMinifiedCard from './SectionMinifiedCard';
import SectionFullCard from './SectionFullCard';
import RouteDefaultsCard from '../RouteDefaultsCard';
import { SECTION_FULL_PAGE } from '../../../../constants/routes';
import palette from '../../../styles/palette';
import {
  getDefaultRoutes,
  getSections,
} from '../../../../store/selectors/sections';
import ListWrapper from '../RouteComponents/ListWrapper';

const useStyles = makeStyles(() => ({
  headerDivider: {
    background: palette.typography.white.neutral,
  },
  divider: {
    height: '0.125rem',
    background: 'transparent',
  },
}));

const colors = ['#84C546', '#44A7DF', '#E3AD1A'];

const SectionList = ({
  onTabChange,
  onSectionClick,
  onSectionDoubleClick,
  selectedSection,
  selectedSectionView,
}) => {
  const styles = useStyles();
  const defaultRoutes = useSelector(getDefaultRoutes);
  const sections = useSelector(getSections);

  return (
    <>
      <DrawerToggle value={selectedSectionView} onChange={onTabChange} />
      <Divider className={styles.headerDivider} />
      <ListWrapper>
        {Object.keys(defaultRoutes).map((routeId) => (
          <Box key={defaultRoutes[routeId].routeName}>
            <Divider className={styles.headerDivider} />
            <RouteDefaultsCard route={defaultRoutes[routeId]} />
          </Box>
        ))}
        {Object.values(sections).map((section, i) => {
          const { sectionCode } = section;

          const Component =
            selectedSectionView === SECTION_FULL_PAGE
              ? SectionFullCard
              : SectionMinifiedCard;

          return (
            <Box key={sectionCode}>
              <Divider className={styles.divider} />
              <Component
                {...section}
                spot={colors[i % 3]}
                active={parseInt(selectedSection) === parseInt(sectionCode)}
                onClick={() => onSectionClick(sectionCode)}
                onDoubleClick={() => onSectionDoubleClick(sectionCode)}
              />
            </Box>
          );
        })}
      </ListWrapper>
    </>
  );
};

export default memo(SectionList);
